"use strict";

exports.__esModule = true;

require('./page.css');

exports.default = {
  "avatar": "pf-c-avatar",
  "brand": "pf-c-brand",
  "button": "pf-c-button",
  "card": "pf-c-card",
  "drawer": "pf-c-drawer",
  "modifiers": {
    "light": "pf-m-light",
    "hidden": "pf-m-hidden",
    "hiddenOnSm": "pf-m-hidden-on-sm",
    "visibleOnSm": "pf-m-visible-on-sm",
    "hiddenOnMd": "pf-m-hidden-on-md",
    "visibleOnMd": "pf-m-visible-on-md",
    "hiddenOnLg": "pf-m-hidden-on-lg",
    "visibleOnLg": "pf-m-visible-on-lg",
    "hiddenOnXl": "pf-m-hidden-on-xl",
    "visibleOnXl": "pf-m-visible-on-xl",
    "hiddenOn_2xl": "pf-m-hidden-on-2xl",
    "visibleOn_2xl": "pf-m-visible-on-2xl",
    "selected": "pf-m-selected",
    "unread": "pf-m-unread",
    "expanded": "pf-m-expanded",
    "collapsed": "pf-m-collapsed",
    "fill": "pf-m-fill",
    "noFill": "pf-m-no-fill",
    "dark_100": "pf-m-dark-100",
    "dark_200": "pf-m-dark-200",
    "padding": "pf-m-padding",
    "noPadding": "pf-m-no-padding",
    "paddingOnSm": "pf-m-padding-on-sm",
    "noPaddingOnSm": "pf-m-no-padding-on-sm",
    "paddingOnMd": "pf-m-padding-on-md",
    "noPaddingOnMd": "pf-m-no-padding-on-md",
    "paddingOnLg": "pf-m-padding-on-lg",
    "noPaddingOnLg": "pf-m-no-padding-on-lg",
    "paddingOnXl": "pf-m-padding-on-xl",
    "noPaddingOnXl": "pf-m-no-padding-on-xl",
    "paddingOn_2xl": "pf-m-padding-on-2xl",
    "noPaddingOn_2xl": "pf-m-no-padding-on-2xl"
  },
  "nav": "pf-c-nav",
  "notificationBadge": "pf-c-notification-badge",
  "page": "pf-c-page",
  "pageDrawer": "pf-c-page__drawer",
  "pageHeader": "pf-c-page__header",
  "pageHeaderBrand": "pf-c-page__header-brand",
  "pageHeaderBrandLink": "pf-c-page__header-brand-link",
  "pageHeaderBrandToggle": "pf-c-page__header-brand-toggle",
  "pageHeaderNav": "pf-c-page__header-nav",
  "pageHeaderTools": "pf-c-page__header-tools",
  "pageHeaderToolsGroup": "pf-c-page__header-tools-group",
  "pageHeaderToolsItem": "pf-c-page__header-tools-item",
  "pageMain": "pf-c-page__main",
  "pageMainBreadcrumb": "pf-c-page__main-breadcrumb",
  "pageMainNav": "pf-c-page__main-nav",
  "pageMainSection": "pf-c-page__main-section",
  "pageMainWizard": "pf-c-page__main-wizard",
  "pageSidebar": "pf-c-page__sidebar",
  "pageSidebarBody": "pf-c-page__sidebar-body"
};